import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatLineModule } from '@angular/material/core';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { QuantityTypeEntity } from '../../../../../dave-data-module/entities/quantity-type.entity';
import { getFetched$ } from '../../../../../dave-data-module/helper/helper';
import { State } from '../../../../../dave-data-module/State';
import { getQuantityTypes, getQuantityTypesFetched } from '../../../../../dave-data-module/State/selectors/accounting.selector';
import { AppButtonModule } from '../../../../../dave-utils-module/app-button-module/app-button.module';
import { QuantityTypeResolver } from '../../../../../dave-data-module/guards/quantity-type.resolver';

export type materialDeviceForm = FormGroup<{
    name: FormControl<string>;
    quantity: FormControl<number>;
    quantityTypeId: FormControl<number>;
}>;
export function createMaterialDeviceForm(value?: materialDeviceForm['value']): materialDeviceForm {
    return new FormGroup({
        name: new FormControl<string>(value?.name, { validators: Validators.required }),
        quantity: new FormControl<number>(value?.quantity, { validators: Validators.required }),
        quantityTypeId: new FormControl<number>(value?.quantityTypeId, { validators: Validators.required }),
    });
}
@Component({
    selector: 'app-construction-diary-material-device-list[forms]',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, MatLineModule, MatListModule, MatInputModule, ReactiveFormsModule, MatOptionModule, MatSelectModule, AppButtonModule],
    templateUrl: './construction-diary-material-device-list.component.html',
    styleUrls: ['./construction-diary-material-device-list.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstructionDiaryMaterialDeviceListComponent {
    @Input() forms: FormArray<materialDeviceForm>;

    protected pendingForm: materialDeviceForm = createMaterialDeviceForm();
    protected quantityTypes$: Observable<QuantityTypeEntity[]>;

    constructor(store: Store<State>, quantityTypeResolver: QuantityTypeResolver) {
        this.quantityTypes$ = getFetched$(store, getQuantityTypesFetched, getQuantityTypes, quantityTypeResolver);
    }
    public pushPendingForm() {
        if (this.pendingForm.valid) {
            this.forms.push(createMaterialDeviceForm(this.pendingForm.value));
            this.pendingForm.reset();
        }
    }
}
